class UserFriendlyError extends Error {
  constructor(message) {
    super(message)
    // a workaround to make `instanceof UserFriendlyError` work in ES5
    this.constructor = UserFriendlyError
    this.__proto__ = UserFriendlyError.prototype
    this.message = message
  }
}

export default UserFriendlyError



// WEBPACK FOOTER //
// ./src/helpers/UserFriendlyError.js